import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { get_pageNavigator1inl9j7ja0vlf as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { goBackOrReplaceWith1hxiq2flhlluq as goBackOrReplaceWith } from '../../../utils/utils.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  UserRole_Admin_getInstance3u101dj1ubbhu as UserRole_Admin_getInstance,
  Party_Client_getInstance1cdrz74lwe2vi as Party_Client_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { LandingScreennv9edtrim3be as LandingScreen } from '../common/LandingScreen.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  Type_Check_getInstance2g1thuyr3vd4k as Type_Check_getInstance,
  ExternalDepositoswk9ddf49t2 as ExternalDeposit,
  ProjectLedgerItem1yul4cns1huli as ProjectLedgerItem,
  get_entries5hqvt5541yea as get_entries,
  _ShortId___init__impl__tlblaa141394eujsnz4 as _ShortId___init__impl__tlblaa,
  ShortId1uz90q3uk7eoq as ShortId,
  Projecto73xqbcrzskm as Project,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { get_lightSection4cpu8okr0w14 as get_lightSection } from '../../theming/sections.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
  get_atEnd1cw5d2zgug26 as get_atEnd,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  get_compact3lsezez8nz8b6 as get_compact,
  dynamicThemexp3sdnaolntz as dynamicTheme,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  title1nssp3ryhwuqj as title,
  body3i5t0n7zprpqb as body,
} from '../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { ProjectStateSemanticzawrm52z9108 as ProjectStateSemantic } from '../../theming/states.mjs';
import { ContractorProject2o386x7rid4t as ContractorProject } from '../contractor/ContractorProject.mjs';
import { label287uhiq3m9m4z as label2 } from '../../components/label2.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isCharSequence1ju9jr1w86plq as isCharSequence,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  And3abx79zpqd7r8 as And,
  andvtrcuje7baox as and,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import {
  get_project24re8n4hoe63y as get_project,
  get_partyq13c2hdc8rqy as get_party,
  get_amount3tpau2iir7fhe as get_amount,
  get_created3mwbwy01g8dq as get_created,
} from '../../../../../../crowpay-shared/com/crowpay/ProjectLedgerItemFields.mjs';
import {
  eq1298m2cje971u as eq,
  gte30bher1s1u7hr as gte,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  weightt34o7llf2uyq as weight,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  take3onnpy6q7ctcz as take,
  plus39kp8wyage607 as plus,
  plus310ted5e4i90h as plus_0,
  toSet2orjxp16sotqu as toSet,
  firstOrNull1982767dljvdy as firstOrNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  ListSemantic_getInstance1hx6c2zatma42 as ListSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { validated3dw9xce8adqbh as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import {
  get_amountdkdz75wuiqhz as get_amount_0,
  get_type1pnmffeobzcga as get_type,
  get_checkNumber2v6cfig98bffw as get_checkNumber,
  get_notes3pjewr1fe36xv as get_notes,
} from '../../../../../../crowpay-shared/com/crowpay/ExternalDepositFields.mjs';
import { lensPath2w8suwoygkj7s as lensPath } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import {
  assert1ckwbdkg35i20 as assert,
  assertReactive30c64mz7ckt8m as assertReactive,
} from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { validategsg6go7eyi9d as validate } from '../../../utils/validation.mjs';
import { MonetaryValueInput2lk8s753hzo22 as MonetaryValueInput } from '../../components/MonetaryValueInput.mjs';
import { issueText2dqtp9rg036jt as issueText } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/validation.mjs';
import { errorTextv58wi1t0me7u as errorText } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../theming/colorManagement.mjs';
import {
  isBlank1dvkhjjvox3p0 as isBlank,
  contains3ue2qo8xhmpf1 as contains,
  substringAfter35b3qhto7hchb as substringAfter,
  trim11nh7r46at6sx as trim,
  substringAfter1hku067gwr5ve as substringAfter_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { nullToBlank2cwx9yazfqg5v as nullToBlank } from '../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../../theming/buttons.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  take9j4462mea726 as take_0,
  drop336950s126lmj as drop,
  takeLast2r8kr8e6g6hi7 as takeLast,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  Formats_getInstance5hp5sczkglnx as Formats_getInstance,
  format1crnfsffhjur0 as format,
} from '../../../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import {
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  Char__rangeTo_impl_tkncvp2wb70up86k2i2 as Char__rangeTo_impl_tkncvp,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substringiqarkczpya5m as substring } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { PaymentTransferMethod_MailedCheck_getInstance2hk9qsxywpjin as PaymentTransferMethod_MailedCheck_getInstance } from '../../../../../../crowpay-shared/com/crowpay/paymentModels.mjs';
import { toggle2o6h9frvgo8sq as toggle } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { toIntOrNull1j8dcc6to13o4 as toIntOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringNumberConversions.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { FormattedTextInput3hltc3nesrzjq as FormattedTextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/FormattedTextInput.commonHtml.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  get_contractorShortIda0pelhgoksfc as get_contractorShortId,
  get_shortIdgzet16nwxhwb as get_shortId,
} from '../../../../../../crowpay-shared/com/crowpay/ProjectFields.mjs';
import { get_waitForNotNull1jl9mx6el51tq as get_waitForNotNull } from '../../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import { NothingHereSemantic_getInstance3tro8v94k1jgs as NothingHereSemantic_getInstance } from '../../theming/appTheme.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = tmp.rfw_1;
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (tmp_0.m88_1.d4(UserRole_Admin_getInstance()) < 0) {
    var tmp_1 = get_pageNavigator($this.win_1);
    goBackOrReplaceWith(tmp_1, AdminExternalDepositPage$render$slambda$lambda);
  }
  return Unit_instance;
}
function AdminExternalDepositPage$render$slambda$lambda() {
  return new (LandingScreen())();
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_issues($this.xin_1);
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!tmp.i1()) {
    $this.yin_1.oam(true);
    return Unit_instance;
  }
  $this.yin_1.oam(false);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.vfw().rfg_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.zin_1;
  var tmp_2 = await_0(this_2, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = tmp_2.v7a_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.xin_1;
  var tmp_4 = await_1(this_3, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp$ret$4 = tmp_4;
  var tmp_5 = tmp_1.qfp(tmp_3, tmp$ret$4, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var tmp_6 = $this.xin_1.iah(new (ExternalDeposit())(Companion_instance.m62(0), null, Type_Check_getInstance(), null), $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  return Unit_instance;
}
function externalDepositForm($this, _this__u8e3s4, project) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  var contractor = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(get_session()).lfv_1.geo($this$remember.daj(project).x7a_1)));
  label2(view, 'Project', VOID, ($this$label2) => {
    var tmp = get_lightSection($this$label2);
    // Inline function 'com.lightningkite.kiteui.views.direct.link' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (Link())($this$label2.pc());
    var tmp0_elvis_lhs = $this$label2.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
    $this$label2.gbb(p, view);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view_0.zbm(false);
    var tmp_0 = view_0.kbb(get_expanding(view_0), get_compact(view_0));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.gbb(p_1, view_1);
    view_1.zbm(true);
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (TextView())(view_1.pc());
    var tmp0_elvis_lhs_2 = view_1.ebb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
    view_1.gbb(p_2, view_2);
    view_2.lba(view_2.qb6_1.abf(BodySemantic_getInstance()));
    var tmp_1 = KMutableProperty0();
    var tmp_2 = TextView$_get_content_$ref_4pzcwl(view_2);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb(view_2));
    reactiveScope(view_2, ($this$reactiveScope) => {
      var tmp$ret$0 = $this$reactiveScope.daj(project).b7b_1;
      this_0.set(tmp$ret$0);
      return Unit_instance;
    });
    view_1.hbb(p_2, view_2);
    // Inline function 'com.crowpay.views.theming.smallBody' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (TextView())(view_1.pc());
    var tmp0_elvis_lhs_3 = view_1.ebb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
    view_1.gbb(p_3, view_3);
    view_3.lba(view_3.qb6_1.abf(SmallBodySemantic_getInstance()));
    var tmp_3 = KMutableProperty0();
    var tmp_4 = TextView$_get_content_$ref_4pzcwl_0(view_3);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb_0(view_3));
    reactiveScope(view_3, ($this$reactiveScope) => {
      var tmp0_safe_receiver = $this$reactiveScope.daj(contractor);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v5i_1;
      var tmp$ret$7 = tmp1_elvis_lhs == null ? 'Contractor...' : tmp1_elvis_lhs;
      this_1.set(tmp$ret$7);
      return Unit_instance;
    });
    view_1.hbb(p_3, view_3);
    view_0.hbb(p_1, view_1);
    view_0.lbb(tmp_0, view_1);
    var tmp_5 = get_centered(view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_4 = view_0.ebb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
    view_0.gbb(p_4, view_4);
    dynamicTheme(view_4, ($this$dynamicTheme) => ProjectStateSemantic().eh1($this$dynamicTheme.daj(project).u7b_1));
    var tmp_6 = KMutableProperty0();
    var tmp_7 = TextView$_get_content_$ref_4pzcwl_1(view_4);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_2 = getPropertyCallableRef('content', 0, tmp_6, tmp_7, TextView$_set_content_$ref_pketfb_1(view_4));
    reactiveScope(view_4, ($this$reactiveScope) => {
      var tmp$ret$18 = $this$reactiveScope.daj(project).u7b_1.u9b_1;
      this_2.set(tmp$ret$18);
      return Unit_instance;
    });
    view_0.hbb(p_4, view_4);
    view_0.lbb(tmp_5, view_4);
    view.hbb(p_0, view_0);
    var tmp_8 = KMutableProperty0();
    var tmp_9 = Link$_get_to_$ref_jq7esp(view);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_3 = getPropertyCallableRef('to', 0, tmp_8, tmp_9, Link$_set_to_$ref_i9gu5x(view));
    reactiveScope(view, ($this$reactiveScope) => {
      var id = $this$reactiveScope.daj(project).v7a_1;
      var tmp$ret$27 = () => new (ContractorProject())(id);
      this_3.set(tmp$ret$27);
      return Unit_instance;
    });
    $this$label2.hbb(p, view);
    return $this$label2.lbb(tmp, view);
  });
  var depositsQuery = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp = $this$remember.daj(get_session()).sfv_1;
    // Inline function 'com.lightningkite.lightningdb.condition' call
    // Inline function 'com.lightningkite.lightningdb.path' call
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(ProjectLedgerItem()), arrayOf([]), false));
    var tmp$ret$32 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$32);
    var tmp_1 = And().v3q([eq(get_project(it), $this$remember.daj(project).v7a_1), eq(get_party(it), Party_Client_getInstance()), gte(get_amount(it), new (MonetaryValue())(Companion_instance.m62(0)))]);
    // Inline function 'com.lightningkite.lightningdb.sort' call
    // Inline function 'kotlin.apply' call
    var this_0 = new (SortBuilder())();
    // Inline function 'com.lightningkite.lightningdb.path' call
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_2 = serializerOrContextual(createKType(getKClass(ProjectLedgerItem()), arrayOf([]), false));
    var tmp$ret$37 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
    var it_0 = new (DataClassPathSelf())(tmp$ret$37);
    this_0.l4a(get_created(it_0));
    var tmp$ret$42 = this_0.m1r();
    return tmp.mdw(new (Query())(tmp_1, tmp$ret$42));
  });
  var deposits = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(depositsQuery)));
  var tmp = view.kbb(shownWhen(view, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.daj(deposits).i1();
  }), get_compact(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(true);
  var truncationLength = 5;
  var truncate = Signal().hak(true);
  var truncatedDeposits = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(truncate) ? take($this$remember.daj(deposits), truncationLength) : $this$remember.daj(deposits));
  bodyBold(view_0, 'Recent Deposits');
  var tmp_0 = view_0.jbb(ListSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(true);
  forEachUpdating(view_1, truncatedDeposits, VOID, AdminExternalDepositPage$externalDepositForm$lambda);
  view_0.hbb(p_1, view_1);
  view_0.lbb(tmp_0, view_1);
  var tmp_1 = view_0.kbb(shownWhen(view_0, VOID, ($this$shownWhen) => $this$shownWhen.daj(deposits).p1() > 5), get_compact(view_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Button())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.gbb(p_2, view_2);
  // Inline function 'com.crowpay.views.theming.smallBody' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.gbb(p_3, view_3);
  view_3.lba(view_3.qb6_1.abf(SmallBodySemantic_getInstance()));
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl_6(view_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb_6(view_3));
  reactiveScope(view_3, ($this$reactiveScope) => {
    var tmp;
    if ($this$reactiveScope.daj(truncate)) {
      var diff = $this$reactiveScope.daj(deposits).p1() - 5 | 0;
      tmp = '...' + diff + ' more, click to show all';
    } else {
      tmp = 'show less';
    }
    var tmp$ret$48 = tmp;
    this_0.set(tmp$ret$48);
    return Unit_instance;
  });
  view_2.hbb(p_3, view_3);
  onClick(view_2, VOID, VOID, AdminExternalDepositPage$externalDepositForm$slambda_0(truncate));
  view_0.hbb(p_2, view_2);
  view_0.lbb(tmp_1, view_2);
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  var deposit = validated(Signal().hak(new (ExternalDeposit())(Companion_instance.m62(0), null, Type_Check_getInstance(), null)));
  var submitFailed = Signal().hak(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (Space())(view.pc());
  var tmp0_elvis_lhs_4 = view.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
  view.gbb(p_4, view_4);
  view.hbb(p_4, view_4);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_5 = view.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
  view.gbb(p_5, view_5);
  view_5.lba(view_5.qb6_1.abf(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_4 = view_5.vb5_1;
  var tmp_5;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('Deposit') === 0) {
    tmp_5 = '\xA0';
  } else {
    tmp_5 = 'Deposit';
  }
  tmp_4.hbu(tmp_5);
  view.hbb(p_5, view_5);
  // Inline function 'com.crowpay.views.components.field2' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_6 = view.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
  view.gbb(p_6, view_6);
  view_6.zbm(true);
  view_6.bb9(get_AppDimensions().pg2_1);
  bodyBold(view_6, 'Amount');
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_6 = view_6.jbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_7 = serializerOrContextual(createKType(getKClass(ExternalDeposit()), arrayOf([]), false));
  var tmp$ret$72 = isInterface(tmp_7, KSerializer()) ? tmp_7 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$72);
  var tmp$ret$74 = get_amount_0(it);
  var tmp_8 = lensPath(deposit, tmp$ret$74);
  var amount = assert(tmp_8, 'Must be greater than 0', VOID, VOID, AdminExternalDepositPage$externalDepositForm$lambda_0);
  var tmp_9 = validate(view_6, amount, ($this$validate) => $this$validate.daj(submitFailed));
  // Inline function 'com.crowpay.views.components.monetaryValueInput' call
  // Inline function 'kotlin.also' call
  var this_1 = new (MonetaryValueInput())(view_6);
  view_6.zah(this_1.ig9_1, amount);
  this_1.vcl('0.00');
  this_1.ega(Companion_instance.m62(0));
  var tmp$ret$78 = this_1.lg9_1;
  view_6.lbb(tmp_9, tmp$ret$78);
  var tmp_10 = get_issues(amount);
  var tmp$ret$79 = issueText(view_6, tmp_10, VOID, ($this$issueText) => $this$issueText.daj(submitFailed));
  view_6.lbb(tmp_6, tmp$ret$79);
  view_6.lbb(view_6.jbb(SubtextSemantic_getInstance()), errorText(view_6));
  view.hbb(p_6, view_6);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_7 = view.ebb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view : tmp0_elvis_lhs_7;
  view.gbb(p_7, view_7);
  view_7.zbm(false);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_11 = serializerOrContextual(createKType(getKClass(ExternalDeposit()), arrayOf([]), false));
  var tmp$ret$85 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$85);
  var tmp$ret$87 = get_type(it_0);
  var type = lensPath(deposit, tmp$ret$87);
  var tmp_12 = get_expanding(view_7);
  // Inline function 'com.crowpay.views.components.field2' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (RowOrCol())(view_7.pc());
  var tmp0_elvis_lhs_8 = view_7.ebb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
  view_7.gbb(p_8, view_8);
  view_8.zbm(true);
  view_8.bb9(get_AppDimensions().pg2_1);
  bodyBold(view_8, 'Type');
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_13 = view_8.jbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.select' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (Select())(view_8.pc());
  var tmp0_elvis_lhs_9 = view_8.ebb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
  view_8.gbb(p_9, view_9);
  var tmp_14 = _Constant___init__impl__v45mub(get_entries());
  view_9.ocf(type, new (Constant())(tmp_14), AdminExternalDepositPage$externalDepositForm$lambda_1);
  view_8.hbb(p_9, view_9);
  view_8.lbb(tmp_13, view_9);
  view_8.lbb(view_8.jbb(SubtextSemantic_getInstance()), errorText(view_8));
  view_7.hbb(p_8, view_8);
  view_7.lbb(tmp_12, view_8);
  var tmp_15 = get_expanding(view_7);
  var tmp_16 = view_7.kbb(tmp_15, shownWhen(view_7, VOID, ($this$shownWhen) => $this$shownWhen.daj(type).equals(Type_Check_getInstance())));
  // Inline function 'com.crowpay.views.components.requiredField' call
  var label = 'Check Number';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (RowOrCol())(view_7.pc());
  var tmp0_elvis_lhs_10 = view_7.ebb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_7 : tmp0_elvis_lhs_10;
  view_7.gbb(p_10, view_10);
  view_10.zbm(true);
  view_10.bb9(get_AppDimensions().pg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (RowOrCol())(view_10.pc());
  var tmp0_elvis_lhs_11 = view_10.ebb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
  view_10.gbb(p_11, view_11);
  view_11.zbm(false);
  view_11.bb9(get_AppDimensions().rg2_1);
  view_11.lbb(get_centered(view_11), bodyBold(view_11, label));
  view_11.lbb(colored(view_11, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_11, '*'));
  view_10.hbb(p_11, view_11);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_17 = view_10.jbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_18 = serializerOrContextual(createKType(getKClass(ExternalDeposit()), arrayOf([]), false));
  var tmp$ret$104 = isInterface(tmp_18, KSerializer()) ? tmp_18 : THROW_CCE();
  var it_1 = new (DataClassPathSelf())(tmp$ret$104);
  var tmp$ret$106 = get_checkNumber(it_1);
  var number = lensPath(deposit, tmp$ret$106);
  assertReactive(number, 'Required for Check Deposits', VOID, ($this$assertReactive, it) => {
    var tmp;
    if (!$this$assertReactive.daj(type).equals(Type_Check_getInstance())) {
      tmp = true;
    } else {
      // Inline function 'kotlin.text.isNullOrBlank' call
      tmp = !(it == null || isBlank(it));
    }
    return tmp;
  });
  var tmp_19 = validate(view_10, number, ($this$validate) => $this$validate.daj(submitFailed));
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (TextInput())(view_10.pc());
  var tmp0_elvis_lhs_12 = view_10.ebb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? view_10 : tmp0_elvis_lhs_12;
  view_10.gbb(p_12, view_12);
  // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
  var value = 'Check Number';
  // Inline function 'com.lightningkite.kiteui.views.placeholder' call
  view_12.vb5_1.bb4_1.kb7_1.placeholder = value;
  view_12.zah(view_12.icn_1, nullToBlank(number));
  view_10.hbb(p_12, view_12);
  view_10.lbb(tmp_19, view_12);
  var tmp_20 = get_issues(number);
  var tmp$ret$114 = issueText(view_10, tmp_20, VOID, ($this$issueText) => $this$issueText.daj(submitFailed));
  view_10.lbb(tmp_17, tmp$ret$114);
  view_7.hbb(p_10, view_10);
  view_7.lbb(tmp_16, view_10);
  view.hbb(p_7, view_7);
  // Inline function 'com.crowpay.views.components.field2' call
  var label_0 = 'Notes (Optional)';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_13 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_13 = view.ebb_1;
  var p_13 = tmp0_elvis_lhs_13 == null ? view : tmp0_elvis_lhs_13;
  view.gbb(p_13, view_13);
  view_13.zbm(true);
  view_13.bb9(get_AppDimensions().pg2_1);
  bodyBold(view_13, label_0);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_21 = view_13.jbb(FieldSemantic_getInstance());
  var tmp_22 = sizeConstraints(view_13, VOID, VOID, get_rem(5));
  // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_14 = new (TextArea())(view_13.pc());
  var tmp0_elvis_lhs_14 = view_13.ebb_1;
  var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
  view_13.gbb(p_14, view_14);
  view_14.vcl('Any additional notes to be put on the ledger item');
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_23 = serializerOrContextual(createKType(getKClass(ExternalDeposit()), arrayOf([]), false));
  var tmp$ret$125 = isInterface(tmp_23, KSerializer()) ? tmp_23 : THROW_CCE();
  var it_2 = new (DataClassPathSelf())(tmp$ret$125);
  var tmp$ret$127 = get_notes(it_2);
  var tmp$ret$128 = lensPath(deposit, tmp$ret$127);
  view_14.zah(view_14.scl_1, nullToBlank(tmp$ret$128));
  view_13.hbb(p_14, view_14);
  var tmp$ret$132 = view_13.lbb(tmp_22, view_14);
  view_13.lbb(tmp_21, tmp$ret$132);
  view_13.lbb(view_13.jbb(SubtextSemantic_getInstance()), errorText(view_13));
  view.hbb(p_13, view_13);
  var tmp_24 = view.kbb(get_atEnd(view), get_primaryButton(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_15 = new (Button())(view.pc());
  var tmp0_elvis_lhs_15 = view.ebb_1;
  var p_15 = tmp0_elvis_lhs_15 == null ? view : tmp0_elvis_lhs_15;
  view.gbb(p_15, view_15);
  specCenteredText(view_15, 'Submit Deposit');
  onClick(view_15, VOID, VOID, AdminExternalDepositPage$externalDepositForm$slambda_2(deposit, submitFailed, project));
  view.hbb(p_15, view_15);
  view.lbb(tmp_24, view_15);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_16 = new (Space())(view.pc(), 5.0);
  var tmp0_elvis_lhs_16 = view.ebb_1;
  var p_16 = tmp0_elvis_lhs_16 == null ? view : tmp0_elvis_lhs_16;
  view.gbb(p_16, view_16);
  view.hbb(p_16, view_16);
  _this__u8e3s4.hbb(p, view);
  return view;
}
var AdminExternalDepositPage$render$slambdaClass;
function AdminExternalDepositPage$render$slambda() {
  if (AdminExternalDepositPage$render$slambdaClass === VOID) {
    class $ {
      constructor($$this$frame) {
        this.win_1 = $$this$frame;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    AdminExternalDepositPage$render$slambdaClass = $;
  }
  return AdminExternalDepositPage$render$slambdaClass;
}
function AdminExternalDepositPage$render$slambda_0($$this$frame) {
  var i = new (AdminExternalDepositPage$render$slambda())($$this$frame);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function AdminExternalDepositPage$render$lambda(it) {
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var str = take_0(it, 8).toUpperCase();
  var first4 = take_0(str, 4);
  var last4 = take_0(drop(str, 4), 4);
  return first4.length >= 4 ? first4 + ' - ' + last4 : first4;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function Link$_get_to_$ref_jq7esp(p0) {
  return () => p0.zbv_1;
}
function Link$_set_to_$ref_i9gu5x(p0) {
  return (_this__u8e3s4) => {
    p0.kbw(_this__u8e3s4);
    return Unit_instance;
  };
}
function AdminExternalDepositPage$externalDepositForm$lambda($this$forEachUpdating, deposit) {
  var tmp = get_lightSection($this$forEachUpdating);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$forEachUpdating.pc());
  var tmp0_elvis_lhs = $this$forEachUpdating.ebb_1;
  var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
  $this$forEachUpdating.gbb(p, view);
  view.zbm(false);
  var tmp_0 = weight(view, 0.7);
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.lba(view_0.qb6_1.abf(BodySemantic_getInstance().abf(BoldSemantic_getInstance())));
  view_0.dbs(Align_Center_getInstance());
  var tmp_1 = KMutableProperty0();
  var tmp_2 = TextView$_get_content_$ref_4pzcwl_2(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_2(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    var tmp$ret$0 = MonetaryValue__toString_impl_xslc77($this$reactiveScope.daj(deposit).s7k_1);
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  view.hbb(p_0, view_0);
  view.lbb(tmp_0, view_0);
  var tmp_3 = weight(view, 1.0);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_1 = view.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.gbb(p_1, view_1);
  view_1.lba(view_1.qb6_1.abf(BodySemantic_getInstance()));
  view_1.dbs(Align_Center_getInstance());
  var tmp_4 = KMutableProperty0();
  var tmp_5 = TextView$_get_content_$ref_4pzcwl_3(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_3(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    var tmp$ret$7 = format($this$reactiveScope.daj(deposit).f7l_1, Formats_getInstance().i8z_1);
    this_1.set(tmp$ret$7);
    return Unit_instance;
  });
  view.hbb(p_1, view_1);
  view.lbb(tmp_3, view_1);
  var tmp_6 = weight(view, 1.3);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_2 = view.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
  view.gbb(p_2, view_2);
  view_2.lba(view_2.qb6_1.abf(BodySemantic_getInstance()));
  view_2.dbs(Align_Center_getInstance());
  var tmp_7 = KMutableProperty0();
  var tmp_8 = TextView$_get_content_$ref_4pzcwl_4(view_2);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb_4(view_2));
  reactiveScope(view_2, ($this$reactiveScope) => {
    var deposit_0 = $this$reactiveScope.daj(deposit);
    var tmp0_subject = deposit_0.y7k_1;
    var tmp;
    switch (tmp0_subject == null ? -1 : tmp0_subject.b4_1) {
      case 0:
      case 1:
      case 2:
        tmp = 'ACH';
        break;
      case 4:
        tmp = 'Wire Transfer';
        break;
      case 3:
        var message = deposit_0.x7k_1;
        var tmp_0;
        var tmp_1;
        // Inline function 'kotlin.text.isNullOrBlank' call

        if (message == null || isBlank(message)) {
          tmp_1 = true;
        } else {
          tmp_1 = !contains(message, 'Check Number:');
        }

        if (tmp_1) {
          tmp_0 = null;
        } else {
          var tmp0 = substringAfter(message, 'Check Number:');
          var tmp$ret$16;
          $l$block: {
            // Inline function 'kotlin.text.takeWhile' call
            var inductionVariable = 0;
            var last = tmp0.length;
            if (inductionVariable < last)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                if (!!(charCodeAt(tmp0, index) === _Char___init__impl__6a9atx(10))) {
                  tmp$ret$16 = substring(tmp0, 0, index);
                  break $l$block;
                }
              }
               while (inductionVariable < last);
            tmp$ret$16 = tmp0;
          }
          // Inline function 'kotlin.text.trim' call
          var this_0 = tmp$ret$16;
          tmp_0 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
        }

        var checkNumber = tmp_0;
        tmp = checkNumber == null ? 'Check' : 'Check (' + checkNumber + ')';
        break;
      case -1:
        tmp = 'N/A';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var tmp$ret$18 = tmp;
    this_2.set(tmp$ret$18);
    return Unit_instance;
  });
  view.hbb(p_2, view_2);
  view.lbb(tmp_6, view_2);
  var tmp_9 = view.kbb(get_centered(view), weight(view, 4.0));
  // Inline function 'com.crowpay.views.theming.smallBody' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_3 = view.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.gbb(p_3, view_3);
  view_3.lba(view_3.qb6_1.abf(SmallBodySemantic_getInstance()));
  view_3.acp(false);
  view_3.zco(true);
  var tmp_10 = KMutableProperty0();
  var tmp_11 = TextView$_get_content_$ref_4pzcwl_5(view_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('content', 0, tmp_10, tmp_11, TextView$_set_content_$ref_pketfb_5(view_3));
  reactiveScope(view_3, ($this$reactiveScope) => {
    var deposit_0 = $this$reactiveScope.daj(deposit);
    var tmp;
    if (equals(deposit_0.y7k_1, PaymentTransferMethod_MailedCheck_getInstance())) {
      var tmp0_safe_receiver = deposit_0.x7k_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : substringAfter_0(tmp0_safe_receiver, _Char___init__impl__6a9atx(10));
      tmp = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    } else {
      var tmp2_elvis_lhs = deposit_0.x7k_1;
      tmp = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
    }
    var tmp$ret$25 = tmp;
    this_3.set(tmp$ret$25);
    return Unit_instance;
  });
  view.hbb(p_3, view_3);
  view.lbb(tmp_9, view_3);
  $this$forEachUpdating.hbb(p, view);
  $this$forEachUpdating.lbb(tmp, view);
  return Unit_instance;
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_6(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_6(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var AdminExternalDepositPage$externalDepositForm$slambdaClass;
function AdminExternalDepositPage$externalDepositForm$slambda() {
  if (AdminExternalDepositPage$externalDepositForm$slambdaClass === VOID) {
    class $ {
      constructor($truncate) {
        this.aio_1 = $truncate;
      }
      uao($completion) {
        toggle(this.aio_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    AdminExternalDepositPage$externalDepositForm$slambdaClass = $;
  }
  return AdminExternalDepositPage$externalDepositForm$slambdaClass;
}
function AdminExternalDepositPage$externalDepositForm$slambda_0($truncate) {
  var i = new (AdminExternalDepositPage$externalDepositForm$slambda())($truncate);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function AdminExternalDepositPage$externalDepositForm$lambda_0(it) {
  return MonetaryValue__compareTo_impl_w7ul1r(it.y5r_1, Companion_instance.m62(0)) > 0;
}
function AdminExternalDepositPage$externalDepositForm$lambda_1(it) {
  return it.b98_1;
}
var AdminExternalDepositPage$externalDepositForm$slambdaClass_0;
function AdminExternalDepositPage$externalDepositForm$slambda_1() {
  if (AdminExternalDepositPage$externalDepositForm$slambdaClass_0 === VOID) {
    class $ {
      constructor($deposit, $submitFailed, $project) {
        this.xin_1 = $deposit;
        this.yin_1 = $submitFailed;
        this.zin_1 = $project;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    AdminExternalDepositPage$externalDepositForm$slambdaClass_0 = $;
  }
  return AdminExternalDepositPage$externalDepositForm$slambdaClass_0;
}
function AdminExternalDepositPage$externalDepositForm$slambda_2($deposit, $submitFailed, $project) {
  var i = new (AdminExternalDepositPage$externalDepositForm$slambda_1())($deposit, $submitFailed, $project);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var AdminExternalDepositPageClass;
function AdminExternalDepositPage() {
  if (AdminExternalDepositPageClass === VOID) {
    class $ {
      constructor() {
        this.nex_1 = Signal().hak('');
      }
      wd6(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        launch(view, VOID, VOID, AdminExternalDepositPage$render$slambda_0(view));
        var tmp_0 = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().gg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        title(view_0, 'External Deposits');
        body(view_0, "Enter the project's reference number below, confirm you have the right project, and then submit the deposit information. This will create a ledger item on the client's behalf.");
        var parsedId = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.takeIf' call
          var this_0 = $this$remember.daj(this.nex_1);
          var tmp;
          if (this_0.length === 8) {
            tmp = this_0;
          } else {
            tmp = null;
          }
          var tmp0_elvis_lhs = tmp;
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            return null;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var str = tmp_0;
          var tmp1_elvis_lhs = toIntOrNull(take_0(str, 4), 16);
          var tmp_1;
          if (tmp1_elvis_lhs == null) {
            return null;
          } else {
            tmp_1 = tmp1_elvis_lhs;
          }
          var contractor = tmp_1;
          var tmp2_elvis_lhs = toIntOrNull(takeLast(str, 4), 16);
          var tmp_2;
          if (tmp2_elvis_lhs == null) {
            return null;
          } else {
            tmp_2 = tmp2_elvis_lhs;
          }
          var project = tmp_2;
          return to(new (ShortId())(_ShortId___init__impl__tlblaa(contractor)), new (ShortId())(_ShortId___init__impl__tlblaa(project)));
        });
        // Inline function 'com.crowpay.views.components.field2' call
        var label = 'Project Reference';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(true);
        view_1.bb9(get_AppDimensions().pg2_1);
        bodyBold(view_1, label);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_1 = view_1.jbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.formattedTextInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (FormattedTextInput())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        view_2.zah(view_2.xbr_1, this.nex_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.FormattedTextInput.hint' call
        var value = '1234-ABCD';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_2.vb5_1.bb4_1.kb7_1.placeholder = value;
        var hexChars = toSet(plus_0(plus(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57)), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(102))), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(70))));
        var tmp_2 = (it) => hexChars.t1(it);
        view_2.bbs(tmp_2, AdminExternalDepositPage$render$lambda);
        view_1.hbb(p_2, view_2);
        view_1.lbb(tmp_1, view_2);
        view_1.lbb(view_1.jbb(SubtextSemantic_getInstance()), errorText(view_1));
        view_0.hbb(p_1, view_1);
        var projectQuery = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0_elvis_lhs = $this$remember.daj(parsedId);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return null;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var _destruct__k2r9zo = tmp;
          var contractorId = _destruct__k2r9zo.cf().l5n_1;
          var projectId = _destruct__k2r9zo.df().l5n_1;
          var tmp_0 = $this$remember.daj(get_session()).rfv_1;
          // Inline function 'com.lightningkite.lightningdb.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
          var tmp$ret$15 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$15);
          var tmp$ret$17 = and(eq(get_contractorShortId(it), new (ShortId())(contractorId)), eq(get_shortId(it), new (ShortId())(projectId)));
          var tmp$ret$18 = new (Query())(tmp$ret$17, orderBy, 0, 1);
          return tmp_0.mdw(tmp$ret$18);
        });
        var project = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = $this$remember.daj(projectQuery);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$remember.daj(tmp0_safe_receiver);
          return tmp1_safe_receiver == null ? null : firstOrNull(tmp1_safe_receiver);
        });
        view_0.lbb(shownWhen(view_0, VOID, ($this$shownWhen) => !($this$shownWhen.daj(project) == null)), externalDepositForm(this, view_0, get_waitForNotNull(project)));
        var tmp_3 = sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(10));
        var tmp_4 = view_0.kbb(tmp_3, shownWhen(view_0, VOID, ($this$shownWhen) => !($this$shownWhen.daj(projectQuery) == null) && $this$shownWhen.daj(project) == null));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Frame())(view_0.pc());
        var tmp0_elvis_lhs_3 = view_0.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
        view_0.gbb(p_3, view_3);
        var tmp_5 = view_3.kbb(get_centered(view_3), view_3.jbb(NothingHereSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowOrCol())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.gbb(p_4, view_4);
        view_4.zbm(true);
        var tmp_6 = get_centered(view_4);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content = 'Not Found';
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (TextView())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.gbb(p_5, view_5);
        view_5.lba(view_5.qb6_1.abf(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_7 = view_5.vb5_1;
        var tmp_8;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content) === 0) {
          tmp_8 = '\xA0';
        } else {
          tmp_8 = content;
        }
        tmp_7.hbu(tmp_8);
        view_4.hbb(p_5, view_5);
        view_4.lbb(tmp_6, view_5);
        view_4.lbb(get_centered(view_4), body(view_4, 'No project was found with the given reference number.'));
        view_3.hbb(p_4, view_4);
        view_3.lbb(tmp_5, view_4);
        view_0.hbb(p_3, view_3);
        view_0.lbb(tmp_4, view_3);
        view.hbb(p_0, view_0);
        view.lbb(tmp_0, view_0);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'AdminExternalDepositPage', AdminExternalDepositPage, VOID, [Page()]);
    AdminExternalDepositPageClass = $;
  }
  return AdminExternalDepositPageClass;
}
//region block: exports
export {
  AdminExternalDepositPage as AdminExternalDepositPage3utp9dihxm4p,
};
//endregion

//# sourceMappingURL=AdminExternalDepositPage.mjs.map
